var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4949_7151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1249 11.5386C17.1014 11.5387 17.078 11.5367 17.0549 11.5327C16.9446 11.5143 16.8461 11.4528 16.7811 11.3619C16.716 11.2709 16.6898 11.1578 16.7081 11.0475L17.13 8.51626C17.1464 8.41761 17.1973 8.32799 17.2736 8.2634C17.35 8.1988 17.4468 8.16342 17.5468 8.16357H20.078C20.1899 8.16357 20.2972 8.20802 20.3763 8.28714C20.4554 8.36626 20.4999 8.47356 20.4999 8.58545C20.4999 8.69734 20.4554 8.80464 20.3763 8.88376C20.2972 8.96288 20.1899 9.00732 20.078 9.00732H17.9045L17.5409 11.1859C17.5245 11.2844 17.4737 11.3739 17.3975 11.4385C17.3214 11.5031 17.2248 11.5385 17.1249 11.5386Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3895 10.8324C20.35 10.7891 20.3019 10.7545 20.2483 10.7308C20.1947 10.7071 20.1367 10.6949 20.0781 10.6948H14.1719C14.1131 10.6946 14.055 10.7066 14.0012 10.7302C13.9473 10.7537 13.899 10.7882 13.8593 10.8315C13.8196 10.8748 13.7893 10.9259 13.7705 10.9815C13.7517 11.0372 13.7447 11.0962 13.75 11.1547L14.5938 20.4359C14.6033 20.5411 14.6519 20.6389 14.73 20.71C14.8081 20.7811 14.91 20.8203 15.0156 20.8198H19.2344C19.34 20.8203 19.4419 20.7811 19.52 20.71C19.5981 20.6389 19.6467 20.5411 19.6563 20.4359L20.5 11.1547C20.505 11.0962 20.4978 11.0374 20.4787 10.9819C20.4597 10.9264 20.4293 10.8754 20.3895 10.8324Z",
    fill: "#CE2600",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.8594 18.2886H8.26562C8.15374 18.2886 8.04643 18.333 7.96731 18.4121C7.8882 18.4913 7.84375 18.5986 7.84375 18.7104C7.84375 19.2699 8.06599 19.8064 8.46157 20.202C8.85716 20.5976 9.39368 20.8198 9.95312 20.8198H14.1719C14.7313 20.8198 15.2678 20.5976 15.6634 20.202C16.059 19.8064 16.2812 19.2699 16.2812 18.7104C16.2812 18.5986 16.2368 18.4913 16.1577 18.4121C16.0786 18.333 15.9713 18.2886 15.8594 18.2886Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.8594 16.6011H8.26562C8.15374 16.6011 8.04643 16.5566 7.96731 16.4775C7.8882 16.3984 7.84375 16.2911 7.84375 16.1792C7.84375 15.6198 8.06599 15.0832 8.46157 14.6876C8.85716 14.2921 9.39368 14.0698 9.95312 14.0698H14.1719C14.7313 14.0698 15.2678 14.2921 15.6634 14.6876C16.059 15.0832 16.2812 15.6198 16.2812 16.1792C16.2812 16.2911 16.2368 16.3984 16.1577 16.4775C16.0786 16.5566 15.9713 16.6011 15.8594 16.6011Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2812 16.6011H7.84375C7.37776 16.6011 7 16.9788 7 17.4448C7 17.9108 7.37776 18.2886 7.84375 18.2886H16.2812C16.7472 18.2886 17.125 17.9108 17.125 17.4448C17.125 16.9788 16.7472 16.6011 16.2812 16.6011Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4949_7151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(7 7.31982)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodPackages);
export default __webpack_public_path__ + "static/media/Food-packages.4a1f491437c8b7040ff6173a26414fa2.svg";
export { ForwardRef as ReactComponent };